import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Confirm, Form } from "semantic-ui-react";
import { useTextResources } from "../language";

export const usePrompt = () => {
    const text = useTextResources()
    
    
    const PromptDialog = ({resolve, additionalFields, ...props})=>{
        const [open, setOpen] =useState(true)
        const [result, setResult] = useState(null)

        useEffect(()=>{
            setOpen(true)
        }, [props.res])


        const cancelHandler = (resolve)=>{
            setOpen(false)
            resolve(null)
        }
        
        const confirmHandler = (resolve)=>{
            setOpen(false)
            resolve(result)
        }
        return <Confirm
        open={open}
        size='tiny'
        closeOnDimmerClick={false}
        confirmButton={{ content: text('OK'), positive: true }}
        cancelButton={{ content: text('Cancel'), negative: true }}
        content={
            <div className='content'>
                <Form>
                    <Form.Input autoFocus label={props.message} onChange={(e, {value})=>setResult(value)}/>
                    {additionalFields}
                </Form>
            </div>
        }
        {...props}
        onCancel={()=>cancelHandler(resolve)}
        onConfirm={()=>confirmHandler(resolve)}
    />
    }
     

    const prompt = (props) => {
        return new Promise((resolve) => {
            var element = document.getElementById('promptContainer');
            if (!element) {
                element = document.createElement('div');
                element.setAttribute('id', 'promptContainer');
                document.body.appendChild(element);
            }
            ReactDOM.render(<PromptDialog {...props} res={Symbol()} resolve={resolve}/>, element)
        });
    }

    return prompt
}
